import { RouteItem } from '@eastcoal/router/types/route'

import { TRADITION_AUCTION_SALE_LIST_PAGE_PATH } from './constants/path'

export const traditionAuctionSaleListRoute: RouteItem = {
  title: '竞拍',
  path: TRADITION_AUCTION_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
